import React from 'react';
import { Box, BoxProps, Stack, styled } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

export type StepIndicatorStates = 'active' | 'complete' | 'incomplete';

interface RoundBoxProps extends BoxProps {
  isMobile?: boolean,
  state: StepIndicatorStates
}

const RoundBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'state'
})<RoundBoxProps>(({ state, theme }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  backgroundColor: state !== 'incomplete' ? theme.palette.primary.main : undefined,
  borderWidth: state !== 'incomplete' ? 0 : 1,
  borderColor: theme.palette.text.secondary,
  borderStyle: 'solid',
  borderRadius: 100,
  width: 40,
  height: 40,
  color: state !== 'incomplete' ? theme.palette.common.white : theme.palette.text.secondary
}));

interface StepIndicatorProps {
  number: number,
  state: StepIndicatorStates
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({number, state}) => {
  return(
    <RoundBox state={state}>
      <Stack alignItems='center' justifyContent='center' flexGrow={1}>
        {state !== 'complete' ?  number : <DoneIcon />}
      </Stack>
    </RoundBox>
  );
};